import { render, staticRenderFns } from "./LinkInBioWrapper.vue?vue&type=template&id=10691900"
import script from "./LinkInBioWrapper.vue?vue&type=script&lang=js"
export * from "./LinkInBioWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports